import { differenceInMinutes } from "date-fns";

/**
 * Returns true when `now` sits within ±windowMinutes of shiftStart. Used to gate
 * the Update-ETA card: we want it visible both before the shift (so workers can
 * update on the way in) and for a window after (so they can update if they're
 * running late), but not indefinitely. The ticket symptom was the card staying
 * visible hours past shift start because the pre-fix check only compared one
 * direction.
 */
export function isWithinEtaUpdateWindow(params: {
  now: Date;
  shiftStart: Date;
  windowMinutes: number;
}): boolean {
  const { now, shiftStart, windowMinutes } = params;
  const minutesFromShiftStart = differenceInMinutes(now, shiftStart);
  return minutesFromShiftStart > -windowMinutes && minutesFromShiftStart < windowMinutes;
}
